"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgeGroupsApplicationService = void 0;
const operators_1 = require("rxjs/operators");
class AgeGroupsApplicationService {
    constructor(repo) {
        this.repo = repo;
    }
    findAgeGroups(tenantId) {
        return this.repo.getForTenant(tenantId);
    }
    async addAgeGroup(command) {
        const ageGroups = await this.repo
            .getForTenant(command.tenantId)
            .pipe(operators_1.first())
            .toPromise();
        if (!ageGroups.mayAddAgeGroup(command.ageGroup)) {
            return { status: 'rejected' };
        }
        const newAgeGroups = ageGroups.withAddedAgeGroup(command.ageGroup);
        await this.repo.put(newAgeGroups);
        return { status: 'accepted' };
    }
    async changeSwitchOverOn(command) {
        const ageGroups = await this.repo
            .getForTenant(command.tenantId)
            .pipe(operators_1.first())
            .toPromise();
        await this.repo.put(ageGroups.withSwitchOverOn(command.switchOverOn));
        return { status: 'accepted' };
    }
    async removeAgeGroup(command) {
        const ageGroups = await this.repo
            .getForTenant(command.tenantId)
            .pipe(operators_1.first())
            .toPromise();
        await this.repo.put(ageGroups.withAgeGroupRemoved(command.ageGroupName));
        return { status: 'accepted' };
    }
    async removeAgeFromAgeGroup(command) {
        const ageGroups = await this.repo
            .getForTenant(command.tenantId)
            .pipe(operators_1.first())
            .toPromise();
        await this.repo.put(ageGroups.withAgeRemovedFromAgeGroup(command.ageGroupName, command.age));
        return { status: 'accepted' };
    }
    async addAgeToAgeGroup(command) {
        const ageGroups = await this.repo
            .getForTenant(command.tenantId)
            .pipe(operators_1.first())
            .toPromise();
        await this.repo.put(ageGroups.withAgeAddedToAgeGroup(command.ageGroupName, command.age));
        return { status: 'accepted' };
    }
    async renameAgeGroup(command) {
        const ageGroups = await this.repo
            .getForTenant(command.tenantId)
            .pipe(operators_1.first())
            .toPromise();
        await this.repo.put(ageGroups.withAgeGroupRenamed(command.ageGroupCurrentName, command.ageGroupNewName));
        return { status: 'accepted' };
    }
}
exports.AgeGroupsApplicationService = AgeGroupsApplicationService;
//# sourceMappingURL=age-groups.application-service.js.map